const map = {
	"./bg-compramos-desktop-dark.png": 25455,
	"./bg-compramos-desktop.png": 44292,
	"./bg-compramos-mobile-dark.png": 27819,
	"./bg-compramos-mobile.png": 82456
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33233;